/**
 * Helpers for reading `contentCard_customID` off a content card.
 *
 * Card IDs are read directly by the card component rather than threaded as a
 * prop, because roughly half the `CardContentItem` call sites (and 3 of 4
 * `CardsGrid` call sites, including the plain grid at CardSection.tsx:754)
 * never pass `variant`/`getCardVariant`. A prop-threaded flag would silently
 * do nothing on the most common section in the CMS.
 */

/**
 * Lowercased, trimmed, and with a leading `#` stripped.
 *
 * The `#` matters: section IDs are stripped (CardSection.tsx:96-99) but card
 * IDs never were, so an author typing "#dialog" — the habit the section field
 * teaches — would otherwise get silence.
 */
export const normalizeCardCustomId = (card: unknown): string =>
  String((card as { contentCard_customID?: unknown } | null)?.contentCard_customID ?? "")
    .toLowerCase()
    .trim()
    .replace(/^#/, "");

/**
 * Exact match, following the `testimonial` convention rather than `price`'s
 * substring test — there is no sub-variant to detect here, and `.includes()`
 * would fire on any future ID containing "dialog".
 */
export const isDialogCard = (card: unknown): boolean =>
  normalizeCardCustomId(card) === "dialog";
